var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallLogsEmptyStateDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 140,
    viewBox: "0 0 220 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3036_742412",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 20,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 20,
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3036_742412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.001 105.417C133.149 105.417 125.26 103.592 117.335 99.9402C109.411 96.2888 102.123 91.1382 95.4726 84.4882C88.849 77.8375 83.7115 70.5562 80.0601 62.6444C76.4087 54.7333 74.583 46.8517 74.583 38.9996C74.583 37.7496 74.9997 36.701 75.833 35.8538C76.6663 35.0072 77.708 34.584 78.958 34.584H92.5476C93.5997 34.584 94.5278 34.9274 95.332 35.6142C96.1361 36.3003 96.6476 37.1482 96.8663 38.1579L99.2549 50.4173C99.4202 51.5548 99.3854 52.5323 99.1507 53.3496C98.9153 54.167 98.4931 54.8534 97.8841 55.409L88.2611 64.7767C89.8097 67.6128 91.5792 70.2958 93.5695 72.8257C95.559 75.3548 97.7132 77.7704 100.032 80.0725C102.318 82.3593 104.749 84.4829 107.324 86.4434C109.899 88.4038 112.679 90.2281 115.665 91.9163L125.015 82.485C125.667 81.8066 126.457 81.3309 127.384 81.0579C128.31 80.7857 129.273 80.7191 130.273 80.8579L141.842 83.2142C142.894 83.492 143.753 84.0288 144.418 84.8246C145.084 85.6204 145.416 86.5232 145.416 87.5329V101.042C145.416 102.292 144.993 103.334 144.147 104.167C143.299 105.001 142.251 105.417 141.001 105.417Z",
    fill: "#383838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogsEmptyStateDark);
export default __webpack_public_path__ + "static/media/call-logs_empty_state_dark.25ad1cb9ae62878706dd7274822a37fa.svg";
export { ForwardRef as ReactComponent };